import SupportService from "@/services/SupportService";

export default {
  async addMessage(text: string, file?: File): Promise<boolean> {
    return await SupportService.postMessage(text, file);
  }
};
